import httpClient from "@utils/httpClient";

export interface ContactSubmission {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string | null;
  subject: string;
  message: string;
  status: 'pending' | 'new' | 'contacted' | 'resolved';
  source: string;
  created_at: string;
}

export interface ContactSubmissionsFilters {
  status?: 'pending' | 'new' | 'contacted' | 'resolved';
  limit?: number;
}

/**
 * Fetch all contact submissions with optional filters
 * Requires JWT authentication
 */
export const getContactSubmissions = async (
  filters?: ContactSubmissionsFilters
): Promise<ContactSubmission[]> => {
  const params = new URLSearchParams();

  if (filters?.status) {
    params.append('status', filters.status);
  }
  if (filters?.limit) {
    params.append('limit', filters.limit.toString());
  }

  const queryString = params.toString();
  const url = `/admin/contact-submissions${queryString ? `?${queryString}` : ''}`;

  const response = await httpClient.get(url);
  return response.data;
};

/**
 * Update contact submission status
 */
export const updateContactStatus = async (
  id: number,
  status: 'pending' | 'new' | 'contacted' | 'resolved'
): Promise<void> => {
  await httpClient.put(`/admin/contact-submissions/${id}`, { status });
};

const ContactSubmissionsService = {
  getContactSubmissions,
  updateContactStatus
};

export default ContactSubmissionsService;
